import Styled from 'styled-components/macro';

export const Title = Styled.div`
	font-size: 14px;
	margin-bottom: 20px;
`;
